import { Route, Routes } from 'react-router-dom'
import Blogs from "./Blogs"
import Causes from "./Causes"
import Dashboard from "./Dashboard"
import Events from "./Events"
import Gallery from "./Gallery"

const RightContent = () => {
    return (
        <div className='w-[100%] h-[calc(100vh-22vh)]  md:h-[100%]  p-2'>

            <Routes>
                <Route index element={<Dashboard />} />
                <Route path='dashboard' element={<Dashboard />} />
                <Route path='gallery' element={<Gallery />} />
                <Route path='events' element={<Events />} />
                <Route path='blogs' element={<Blogs />} />
                <Route path='cause' element={<Causes />} />
            </Routes>

        </div>
    )
}

export default RightContent
